// src/channel-partners/adminChannelPartnerWebhooksApi.ts
import { apiClient } from "@maat/api-base";
var adminChannelPartnerWebhooksApi = {
  /** The delivery log, newest first. Every filter narrows SERVER-side. */
  listDeliveries: async (params) => apiClient.get("/main/api/admin/channel-partners/webhook-deliveries", { params }),
  /** The KPI strip. One backend pass, so the numbers cannot disagree. */
  deliveryStats: async (params) => apiClient.get("/main/api/admin/channel-partners/webhook-deliveries/stats", { params }),
  /**
   * Put ONE parked delivery back in the queue. Per-row rather than "redrive
   * everything": an endpoint that is still wrong would burn their whole
   * backlog's attempts in one tick. Refuses with `409` when the payload was erased or
   * purged — nothing is left to send, and saying so beats a success the dispatcher
   * then silently skips.
   */
  redriveDelivery: async (id) => apiClient.post(
    `/main/api/admin/channel-partners/webhook-deliveries/${encodeURIComponent(id)}/redrive`
  ),
  /** A developer's registered endpoint, and whether signing is configured at all. */
  getEndpoint: async (partnerId, params) => apiClient.get(
    `/main/api/admin/channel-partners/${encodeURIComponent(partnerId)}/webhook-endpoint`,
    { params }
  ),
  /**
   * Mint the next signing secret, keeping the previous one alive for an overlap
   * window. Responds with the plaintext secret — the ONLY time it exists; the
   * database stores a generation number, so there is nothing to read it back from.
   */
  rotateSecret: async (partnerId, data) => apiClient.post(
    `/main/api/admin/channel-partners/${encodeURIComponent(partnerId)}/webhook-endpoint/rotate-secret`,
    data ?? {}
  ),
  /**
   * Support's "Send test event": the developer console's own test delivery, to the
   * endpoint of the named environment, counted against the OPERATOR's allowance for this
   * developer. Answers ids only — this console is envelope-only.
   */
  sendTestEvent: async (partnerId, data) => apiClient.post(
    `/main/api/admin/channel-partners/${encodeURIComponent(partnerId)}/webhook-endpoint/test`,
    data
  )
};

export {
  adminChannelPartnerWebhooksApi
};
